export default __webpack_public_path__ + "static/media/collections_6.29a377cf.webp";